module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_9016.ddd156f7.png";